import NewsUpdatesTable from './NewsUpdatesTable';

export default NewsUpdatesTable;
